import type { TypePolicies } from '@apollo/client';

export const typePolicies = {
  /**
   * Custom client side only TypePolicies.
   * See `customPossibleTypes.js`.
   */
  NonNormalizedMergedTypes: {
    merge: true,
  },
  NonNormalizedUnMergedTypes: {
    keyFields: false,
  },
  SingletonTypes: {
    keyFields: [],
  },
  /**
   * Non-unique types.
   * Provide a more specific key for data normalization to happen.
   */
  Incentive: {
    keyFields: ['id', 'enabled'],
  },
  SelectIntOption: {
    keyFields: ['id', 'name'],
  },
  SelectMultilingualStringOption: {
    keyFields: ['id', 'name'],
  },
  SelectStringOption: {
    keyFields: ['id', 'name'],
  },
} as TypePolicies;
